import React, { Suspense } from 'react';
import debounce from 'lodash/debounce';
import { connect } from 'react-redux';
import { subscribe, unsubscribe, publish } from '@wh/message-bus';
import MESSAGE_BUS_TOPICS from '@wh/message-bus-topics';
import { getDeviceInfo } from '../../../utils/deviceInfo';
import config from '../../../config';
import { publishOnLoginOpen, publishOpenByoMenuAnalytics } from '../../analyticsHelpers';
import { OPEN_BUILD_YOUR_ODDS_EVENT, CLOSE_BUILD_YOUR_ODDS_MODAL, OPEN_BUILD_YOUR_ODDS_MODAL, GET_ODDS_FORMAT, START_NEW_LOGIN_PROCESS, BYO_CAMPAIGN_QUERY_PARAM, EDIT_BUILD_YOUR_ODDS_SELECTION, } from '../../../constants';
import { App } from '../ui';
import * as actions from '../../../redux/actions';
const shouldUseBYOFreedom = () => {
    const { useBYOFreedom, byoFreedomEnabled, byoMarketsEnabled } = config;
    if (byoFreedomEnabled && !byoMarketsEnabled) {
        return true;
    }
    if (!byoFreedomEnabled && byoMarketsEnabled) {
        return false;
    }
    return useBYOFreedom;
};
let currentEventId = '';
export class AppComponent extends React.PureComponent {
    constructor(props) {
        super(props);
        this.subscriptionToken = [];
        this.openCurrentEvent = debounce(() => {
            const { getMarkets, clearSlip } = this.props;
            const { locale, eventId } = config;
            if (currentEventId !== eventId) {
                clearSlip();
                currentEventId = eventId;
            }
            if (eventId) {
                getMarkets(locale, eventId, shouldUseBYOFreedom());
                this.open();
            }
        }, 20, { leading: true, trailing: true });
        this.openLoginModal = () => {
            const { setWaitingForLogin } = this.props;
            const deviceInfo = getDeviceInfo();
            // Update state
            setWaitingForLogin(true);
            if (deviceInfo && deviceInfo.isNative && window) {
                window.location.href = 'nw-showlogin://';
            }
            else {
                // open old loggin
                const login = document.querySelector('#account-section section.account');
                if (login) {
                    login.classList.add('-expanded');
                }
                // open new loggin
                publish(START_NEW_LOGIN_PROCESS, {});
            }
            publishOnLoginOpen();
        };
        this.pushHistoryState = () => {
            const { history, location } = this.props;
            const pathname = window ? window.location.pathname : location.pathname;
            history.push({ pathname, state: config.locationState });
        };
        this.openEvent = (topic, payload) => {
            const { getMarkets, isModalOpen, clearSlip } = this.props;
            const { locale, useBYOFreedom } = config;
            clearSlip();
            getMarkets(locale, payload.eventId, useBYOFreedom);
            if (!isModalOpen) {
                this.open();
            }
        };
        this.editSelection = (topic, payload) => {
            const { editSelections, isModalOpen, clearSlip } = this.props;
            clearSlip();
            editSelections(payload);
            if (!isModalOpen) {
                this.open();
            }
        };
        this.open = () => {
            const { isUserLoggedIn, openModal } = this.props;
            if (isUserLoggedIn) {
                publishOpenByoMenuAnalytics();
                const { pushHistoryState } = this;
                pushHistoryState();
                openModal();
            }
            else {
                this.openLoginModal();
            }
        };
        this.close = () => {
            const { closeModal, history } = this.props;
            // Unset BYO location
            history.goBack();
            closeModal();
        };
        this.setOddsFormat = (topic, payload) => {
            const { addOddsFormatToStore } = this.props;
            addOddsFormatToStore(payload);
        };
        this.setLoggedInState = (topic, { isLoggedIn }) => {
            const { setUserLoggedInState, isModalOpen, isWaitingForLogin, setWaitingForLogin, isOpeningFromCampaign, setIsOpeningFromCampaign, } = this.props;
            setUserLoggedInState(isLoggedIn);
            // Persist opening on campaign trigger
            if (isOpeningFromCampaign) {
                setIsOpeningFromCampaign(false);
                return;
            }
            if (isWaitingForLogin && isLoggedIn) {
                this.open();
            }
            else if (isModalOpen) {
                this.close();
            }
            setWaitingForLogin(false);
        };
        this.subscriptionToken = [
            subscribe(OPEN_BUILD_YOUR_ODDS_EVENT, this.openEvent),
            subscribe(OPEN_BUILD_YOUR_ODDS_MODAL, this.openCurrentEvent),
            subscribe(EDIT_BUILD_YOUR_ODDS_SELECTION, this.editSelection),
            subscribe(CLOSE_BUILD_YOUR_ODDS_MODAL, this.close),
            subscribe(GET_ODDS_FORMAT, this.setOddsFormat),
            subscribe(MESSAGE_BUS_TOPICS.COMMON.LOGIN_STATE, this.setLoggedInState),
        ];
        this.checkByoInUrl();
    }
    componentDidUpdate() {
        const { location, isModalOpen, openModal } = this.props;
        if (location.state === config.locationState && !isModalOpen) {
            openModal();
        }
    }
    componentWillUnmount() {
        this.subscriptionToken.forEach((token) => unsubscribe(token));
    }
    // To navigate to an event and open byo directly, used in emails campaigns and banners
    checkByoInUrl() {
        const { history, location, setIsOpeningFromCampaign } = this.props;
        const queryParams = new URLSearchParams(location.search);
        if (queryParams.has(BYO_CAMPAIGN_QUERY_PARAM)) {
            queryParams.delete(BYO_CAMPAIGN_QUERY_PARAM);
            history.replace({
                search: queryParams.toString(),
            });
            setIsOpeningFromCampaign(true);
            this.openCurrentEvent();
        }
    }
    render() {
        const { isModalOpen, slipExpanded, expandSlip, addingToBetslip, location, } = this.props;
        if (!isModalOpen) {
            return null;
        }
        if (location.state === config.locationState) {
            return (React.createElement(Suspense, { fallback: "" },
                React.createElement(App, { slipExpanded: slipExpanded, expandSlip: expandSlip, addingToBetslip: addingToBetslip })));
        }
        return null;
    }
}
const mapStateToProps = ({ slip, app, auth, }) => (Object.assign(Object.assign(Object.assign({}, slip), app), auth));
const mapDispatchToProps = {
    getMarkets: actions.getMarkets,
    editSelections: actions.editSelections,
    addOddsFormatToStore: actions.addOddsFormatToStore,
    expandSlip: actions.expandSlip,
    openModal: actions.openModal,
    closeModal: actions.closeModal,
    clearSlip: actions.clearSlip,
    setUserLoggedInState: actions.setUserLoggedInState,
    setWaitingForLogin: actions.setWaitingForLogin,
    setIsOpeningFromCampaign: actions.setIsOpeningFromCampaign,
};
export const ConnectedApp = connect(mapStateToProps, mapDispatchToProps)(AppComponent);
